import { render } from "./Modal.vue?vue&type=template&id=f8972e7e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=f8972e7e&lang=css"
script.render = render

export default script